import { useState, Fragment } from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
import MuiMenu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Collapse from '@mui/material/Collapse';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import BarChartIcon from '@mui/icons-material/BarChart';
import SportsEsportsIcon from '@mui/icons-material/SportsEsports';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import HamburgerMenu from './Menu';
import HeaderLogo from './HeaderLogo';
import groupGameTypes from '../../lib/groupGameTypes';

const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const Header = (props) => {
  const [ modeMenuAnchor, setModeMenuAnchor ] = useState(null);
  const [ openGroup, setOpenGroup ] = useState(null);

  const handleModeIconClick = (event) => {
    event.currentTarget.blur();
    setModeMenuAnchor(event.currentTarget);
  };

  const handleModeMenuClose = () => {
    setModeMenuAnchor(null);
    setOpenGroup(null);
  };

  const handleModeSelect = (slug) => {
    document.activeElement?.blur();
    props.onGameTypeChange(null, slug);
    setOpenGroup(null);
    setModeMenuAnchor(null);
  };

  const handleGroupSelect = (slug) => {
    document.activeElement?.blur();
    props.onGameTypeChange(null, slug);
    setOpenGroup(null);
    setModeMenuAnchor(null);
  };

  const availableGameTypes = props.availableGameTypes || [];
  const { topLevel, groups } = groupGameTypes(availableGameTypes);

  return (
		<Container>
			<Box sx={{ height: '48px', display: 'flex', mb: 1, pt: 1 }}>
				<Stack direction="row" width="100%" justifyContent="space-between" pt={1} pb={1}>
          <HamburgerMenu showHelp={props.showHelp} setShowHelp={props.setShowHelp} showResults={props.showResults} setShowResults={props.setShowResults} availableGameTypes={availableGameTypes} activeGameTypeSlug={props.activeGameTypeSlug} onGameTypeChange={props.onGameTypeChange} colourBlindMode={props.colourBlindMode} onColourBlindToggle={props.onColourBlindToggle} />
					<HeaderLogo />
          <Stack direction="row">
            <IconButton onClick={handleModeIconClick} aria-label="select game mode" disabled={availableGameTypes.length === 0}>
              <Badge
                badgeContent="NEW"
                sx={{ '& .MuiBadge-badge': { fontSize: '8px', height: '14px', minWidth: '30px', borderRadius: '3px', padding: '0 3px', backgroundColor: 'primary.main', color: 'primary.contrastText' } }}
              >
                <SportsEsportsIcon />
              </Badge>
            </IconButton>
            <IconButton onClick={() => { document.activeElement?.blur(); props.setShowHelp(true); }} aria-label="view help">
              <HelpOutlineIcon />
            </IconButton>
            <IconButton onClick={() => { document.activeElement?.blur(); props.setShowResults(true); }} aria-label="view results">
              <BarChartIcon />
            </IconButton>
            <MuiMenu anchorEl={modeMenuAnchor} open={Boolean(modeMenuAnchor)} onClose={handleModeMenuClose} transitionDuration={0}>
              {topLevel.map((gt) => (
                <MenuItem
                  key={gt.slug}
                  selected={gt.slug === props.activeGameTypeSlug}
                  onClick={() => handleModeSelect(gt.slug)}
                >
                  {gt.name || capitalize(gt.slug)}
                </MenuItem>
              ))}
              {Object.entries(groups).map(([prefix, types]) => {
                const isGroupActive = types.some(gt => gt.slug === props.activeGameTypeSlug);
                const isExpanded = openGroup === prefix;
                return (
                  <Fragment key={prefix}>
                    <MenuItem selected={isGroupActive} onClick={() => setOpenGroup(isExpanded ? null : prefix)}>
                      {capitalize(prefix)}
                      {isExpanded
                        ? <ExpandLessIcon sx={{ ml: 'auto', fontSize: 18 }} />
                        : <ChevronRightIcon sx={{ ml: 'auto', fontSize: 18 }} />
                      }
                    </MenuItem>
                    <Collapse in={isExpanded} timeout="auto">
                      {types.map(gt => (
                        <MenuItem
                          key={gt.slug}
                          selected={gt.slug === props.activeGameTypeSlug}
                          onClick={() => handleGroupSelect(gt.slug)}
                          sx={{ pl: 4 }}
                        >
                          {gt.name || capitalize(gt.slug)}
                        </MenuItem>
                      ))}
                    </Collapse>
                  </Fragment>
                );
              })}
            </MuiMenu>
          </Stack>
				</Stack>
			</Box>
		</Container>
	);
};

export default Header;
